export default __webpack_public_path__ + "static/media/mode_fan.b99a3337.svg";